import type { FaireProductEntity } from "../../entity_types/product";

export const p_259bjb48rt: FaireProductEntity = {
  token: "p_259bjb48rt",
  type: "product",
  name: "MN Months Socks",
  brandName: "Adam Turman Artwork Co",
  imageUrl:
    "https://cdn.faire.com/fastly/d5468ff9236d823b626afcf2e904f31b067d226ee17f050b9ecc42038e4c2593.jpeg",
  priceDollars: 5.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/43459383460ca2fb5f3fc971215f1e2635d29a4ec30d6f8a89b5c1eb21508054.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
